import * as yup from 'yup';
import * as formSchemaUtils from './formSchemaUtils';
import { fieldKey } from '../constants';

const getBatchUpdateFormSchema = selectedFields => {
  let selectedFieldsList = Object.keys(selectedFields).map(entry => selectedFields[entry].key);

  let envAttrsDynamicRequired = {};
  Object.keys(selectedFieldsList).forEach(k => {
    if (fieldKey.envAttrs[selectedFieldsList[k]] !== undefined) {
      Object.assign(envAttrsDynamicRequired, {
        [fieldKey.envAttrs[selectedFieldsList[k]]]: formSchemaUtils.objectWithIdRequired()
      });
    }
  });

  return yup.object().shape({
    ...(selectedFieldsList.includes(fieldKey.GEN_LOCATION_NAME) && {
      outOfBuilding: yup
        .mixed()
        .outOfBuildingRequiredValidation(yup.ref('location.locationInfo'))
        .outOfBuildingErrorValidation(yup.ref('location.locationInfo'))
        .nullable(),
      location: formSchemaUtils.objectRequired()
    }),
    ...(selectedFieldsList.includes(fieldKey.GEN_CONTACTS) && {
      contacts: yup.mixed().test('contacts', formSchemaUtils.LIST_CANNOT_BE_EMPTY, value => {
        return (
          value &&
          value.length > 0 &&
          value.filter(
            v => !v['wasDeleted'] && (!v['delDte'] || new Date(v['delDte']) > new Date())
          ).length > 0
        );
      })
    }),

    ...(selectedFieldsList.includes(fieldKey.GEN_QUANTITY) && {
      quantity: yup
        .number()
        .min(0, formSchemaUtils.VALUE_MUST_BE_POSITIVE_INTEGER)
        .max(999999999999999999, formSchemaUtils.VALUE_EXCEEDS_MAX)
        .required(formSchemaUtils.VALUE_IS_REQUIRED)
        .nullable()
    }),

    ...(selectedFieldsList.includes(fieldKey.GEN_TRADE_NAME) && {
      chemicalProduct: yup.object().shape({
        selectedChemicalProduct: formSchemaUtils.objectWithIdRequired()
      })
    }),
    ...(selectedFieldsList.some(r => Object.keys(fieldKey.envAttrs).includes(r)) && {
      envAttributes: yup.object(envAttrsDynamicRequired)
    })
  });
};

export default getBatchUpdateFormSchema;
